























import Vue from 'vue'
import { GetKopfFussResponse, UpdateKopfFussResponse } from '@/types/service-response'
import { GET_PROJECT_HEADER_FOOTER_TEXT, UPDATE_PROJECT_HEADER_FOOTER_TEXT } from '@/store/action-types'
import { ProjectReprintHeaderFooterText } from '@/model/project/ProjectReprintHeaderFooterText'
import { KopfFussDataPayload } from '@/types/payload'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'

interface ComponentData {
  id: number | undefined
  kopfText: string
  fussText: string

  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
}

export default Vue.extend({
  name: 'ProjectReprintHeaderFooterText',

  components: {

  },

  props: {
    belegId: Number
  },

  data (): ComponentData {
    return {
      id: undefined,
      kopfText: '',
      fussText: '',

      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false
    }
  },

  watch: {
    belegId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchData()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  methods: {
    onCancelButtonClick (): void {
      if(this.belegId) {
        this.fetchData()
      }
    },

    onSaveButtonClick (): void {
      if(this.id) {
        this.saveHeaderFooterText()
      }
    },

    async saveHeaderFooterText (): Promise<void> {
      const payload: KopfFussDataPayload = {
        ID: this.id!,
        KopfText: this.kopfText,
        FussText: this.fussText
      }

      try {
        this.loading = true
        const response: UpdateKopfFussResponse = await this.$store.dispatch(UPDATE_PROJECT_HEADER_FOOTER_TEXT, payload)
        this.loading = false
        if(!response.IsError) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      const response: GetKopfFussResponse = await this.$store.dispatch(GET_PROJECT_HEADER_FOOTER_TEXT, this.belegId)
      if(!response.IsError && response.Data) {
        const data: ProjectReprintHeaderFooterText = ProjectReprintHeaderFooterText.createFromResponse(response.Data)
        this.id = data.id
        this.kopfText = data.kopfText
        this.fussText = data.fussText
      }
    }
  },

  mounted () {
    if(this.belegId) {
      this.fetchData()
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 100)
  }
})
